import React from 'react';
import computingImage from '../../static/computing_image/computing_main.png';
import AnnotatedImage, {
    AutoImageProps,
    processLabelToComponentName,
} from '../automotivePage/CarImageComponent';
import { ApplicationsComputingAndEnterpriseSystemsComputingImageMapLinkTextsContent } from '../../graphql/pimcore/modules/siteContent/types/ApplicationsContent';

function generateLabelToComponentMap(
    t: ApplicationsComputingAndEnterpriseSystemsComputingImageMapLinkTextsContent
): Record<string, string> {
    return {
        [t.climateControl.content]: 'climatecontrol',
        [t.upsBatteries.content]: 'upsbatteries',
        [t.mainPowerDistribution.content]: 'mainpowerdistribution',
        [t.edgeComputing.content]: 'edgecomputing',
        [t.generator.content]: 'generator',
        [t.networkPowerChiller.content]: 'networkpowerchiller',
        [t.apc.content]: 'apc',
        [t.pcsAndNotebooks.content]: 'pcsandnotebooks',
        [t.server.content]: 'server',
    };
}

const DefaultComputing: React.FC<AutoImageProps> = ({ onAnnotationClick, contentTree }) => {
    const imageMap = contentTree.ComputingAndEnterpriseSystems.Computing.imageMapLinkTexts;
    const labelToComponentMap = generateLabelToComponentMap(imageMap);

    const annotations = [
        {
            label: imageMap.climateControl.content,
            pointX: 190,
            pointY: 460,
            labelX: 208,
            labelY: 300,
            lineStartAdjust: 9,
            lineToLabelGap: -10,
            lineToPointGap: -30,
        },
        {
            label: imageMap.upsBatteries.content,
            pointX: 350,
            pointY: 365,
            labelX: 370,
            labelY: 220,
            lineStartAdjust: 9,
            lineToLabelGap: -10,
            lineToPointGap: -30,
        },
        {
            label: imageMap.mainPowerDistribution.content,
            pointX: 580,
            pointY: 250,
            labelX: 598,
            labelY: 150,
            lineStartAdjust: 9,
            lineToLabelGap: -15,
            lineToPointGap: -30,
        },
        {
            label: imageMap.edgeComputing.content,
            pointX: 810,
            pointY: 105,
            labelX: 830,
            labelY: 35,
            lineStartAdjust: 9,
            lineToLabelGap: -15,
            lineToPointGap: -30,
        },
        {
            label: imageMap.networkPowerChiller.content,
            pointX: 920,
            pointY: 495,
            labelX: 938,
            labelY: 610,
            lineStartAdjust: 7,
            lineToLabelGap: -8,
            lineToPointGap: -12,
        },
        {
            label: imageMap.generator.content,
            pointX: 1055,
            pointY: 420,
            labelX: 1073,
            labelY: 530,
            lineStartAdjust: 7,
            lineToLabelGap: -10,
            lineToPointGap: -16,
        },
        {
            label: imageMap.apc.content,
            pointX: 760,
            pointY: 655,
            labelX: 780,
            labelY: 760,
            lineStartAdjust: 6,
            lineToLabelGap: -5,
            lineToPointGap: -10,
        },
        {
            label: imageMap.pcsAndNotebooks.content,
            pointX: 415,
            pointY: 695,
            labelX: 430,
            labelY: 965,
            lineStartAdjust: 7,
            lineToLabelGap: -5,
            lineToPointGap: -10,
        },
        {
            label: imageMap.server.content,
            pointX: 310,
            pointY: 750,
            labelX: 327,
            labelY: 900,
            lineStartAdjust: 7,
            lineToLabelGap: -5,
            lineToPointGap: -10,
        },
    ];

    return (
        <AnnotatedImage
            imageSrc={computingImage}
            annotations={annotations}
            onAnnotationClick={(rawLabel) => {
                const labelString = Array.isArray(rawLabel) ? rawLabel.join(' ') : rawLabel;
                const key =
                    labelToComponentMap[labelString] ?? processLabelToComponentName(labelString);
                onAnnotationClick(key);
            }}
            imageStyle={{
                marginBottom: '2rem',
                marginTop: '2rem',
                marginLeft: '1rem',
                width: '99%',
                height: 'auto',
            }}
            viewBox="0 0 1200 976"
            isDefaultImage
        />
    );
};

export { DefaultComputing };
